import { Link } from 'react-router-dom';

export default function SafetySection() {
  const tips = [
    {
      title: 'Secure Shopping',
      desc: 'Learn how to identify trustworthy product listings and avoid common online shopping pitfalls when using the spreadsheet.',
      icon: 'ri-shield-check-line',
    },
    {
      title: 'Payment Awareness',
      desc: 'Understand safe payment practices, recognize secure checkout processes, and protect your financial information.',
      icon: 'ri-bank-card-line',
    },
    {
      title: 'Shipping Information',
      desc: 'Get familiar with shipping policies, delivery timeframes, and tracking methods for a smooth post-purchase experience.',
      icon: 'ri-truck-line',
    },
    {
      title: 'Scam Prevention',
      desc: 'Spot red flags early with our comprehensive guide to identifying and avoiding fraudulent product listings.',
      icon: 'ri-alert-line',
    },
  ];

  return (
    <section id="safety" className="w-full py-16 md:py-24 bg-background-100/60">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-12">
          <span className="text-xs font-semibold uppercase tracking-widest text-accent-500">Safety First</span>
          <h2 className="mt-2 text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            Shop with <span className="text-primary-500">Confidence</span>
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-lg mx-auto">
            Our guides focus on keeping your shopping experience safe, secure, and worry-free
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {tips.map((tip, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl border border-background-200/60 p-6 md:p-7 text-center group hover:border-primary-300/50 transition-all duration-300"
            >
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-2xl bg-accent-100 text-accent-600 mb-5">
                <i className={`${tip.icon} text-2xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2">{tip.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{tip.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 bg-background-50 rounded-xl border border-background-200/60 p-6 md:p-8">
          <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-5">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 flex-shrink-0">
                <i className="ri-information-line text-2xl"></i>
              </div>
              <div>
                <h4 className="text-base font-semibold text-foreground-950">Safety Disclaimer</h4>
                <p className="mt-1 text-sm text-foreground-500 leading-relaxed max-w-2xl">
                  Vigorbuy Spreadsheet is a product discovery resource. We provide guides and information to help you shop safely. Always verify product details and seller information on the actual marketplace before making a purchase. When in doubt, consult our detailed safety guides.
                </p>
              </div>
            </div>
            <Link
              to="/article/vigorbuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-950 text-background-50 text-sm font-semibold rounded-full hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap flex-shrink-0 cursor-pointer"
            >
              Read Safety Guide
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}